var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { connect } from 'react-redux';
import { languages } from 'app/utils/supportedLanguages';
import { withRouter } from 'hocs/router';
import satisfactionActions from '../../../actions/satisfaction';
import { EmailPanel, } from '../../../components/sections/satisfaction/components/EmailCSAT/EmailPanel/EmailPanel';
import { emailListAll as createLoadAllEmailsAction } from '../../../reducers/sections/email';
const mapStateToProps = (state) => ({
    globalSettings: {
        values: state.settings.satisfaction.customization.email.globalLevel.values,
        asyncStatus: state.settings.satisfaction.customization.email.globalLevel.asyncStatus,
    },
    emailAccountsSettings: {
        asyncStatus: state.settings.email.meta.asyncStatus,
        list: state.settings.email.emailList.map((emailIntegration) => {
            var _a;
            const correspondingSettings = (_a = state.settings.satisfaction.customization.email.contactPointsLevel.values) === null || _a === void 0 ? void 0 : _a.find(({ contactPoint }) => contactPoint === emailIntegration.email_address);
            if (correspondingSettings) {
                return {
                    address: emailIntegration.email_address,
                    enabled: correspondingSettings.enabled,
                    settings: correspondingSettings,
                };
            }
            return {
                address: emailIntegration.email_address,
                enabled: false,
                settings: null,
            };
        }),
    },
    languagesSettings: {
        list: languages.map(({ code, label }) => {
            var _a;
            const correspondingSettings = (_a = state.settings.satisfaction.customization.email.languagesLevel.values) === null || _a === void 0 ? void 0 : _a.find(({ language }) => language === code);
            if (correspondingSettings) {
                return { code, label, settings: correspondingSettings };
            }
            return { code, label, settings: null };
        }),
        asyncStatus: state.settings.satisfaction.customization.email.languagesLevel
            .asyncStatus,
    },
});
const mapDispatchToProps = (dispatch) => {
    return {
        loadAllEmails() {
            dispatch(createLoadAllEmailsAction());
        },
        loadEmailSettingsAllLevels() {
            dispatch(satisfactionActions.satisfactionLoadEmailAllLevelsSettingsRequest());
        },
        initializeEmailCsat() {
            dispatch(satisfactionActions.satisfactionInitializeRequest('email'));
        },
        createGlobalSettings: (settings) => {
            const action = satisfactionActions.satisfactionSaveEmailGlobalSettingsRequest(settings, { edit: false });
            dispatch(action);
        },
        updateGlobalSettings: (settings) => {
            const action = satisfactionActions.satisfactionSaveEmailGlobalSettingsRequest(settings, { edit: true });
            dispatch(action);
        },
        updateEmailLevelSettings: (_a) => {
            var { settings } = _a, change = __rest(_a, ["settings"]);
            const action = satisfactionActions.satisfactionSaveEmailContactLevelSettingsRequest(change, settings);
            dispatch(action);
        },
        updateLanguageLevelSettings(payload) {
            const action = satisfactionActions.satisfactionSaveEmailLanguageLevelSettingsRequest(payload);
            dispatch(action);
        },
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmailPanel));
